import type { ScheduledEmail } from "../types";
import type { ScheduledEmailApi } from "../../../../api/campaigns";

interface MapScheduledEmailsOptions {
  campaignId?: string;
  campaignName?: string;
}

export const mapScheduledEmailsFromApi = (
  items: ScheduledEmailApi[] | undefined,
  options?: MapScheduledEmailsOptions
): ScheduledEmail[] => {
  if (!items?.length) {
    return [];
  }

  return items.map((item) => ({
    id: item.id,
    userId: item.userId,
    email: item.email,
    createdAt: item.createdAt,
    userTimezone: item.userTimezone,
    scheduledFor: item.scheduledFor,
    scheduledForLocal: item.scheduledForLocal,
    jobType: item.jobType,
    sequenceIndex: item.sequenceIndex,
    emailSubject: item.emailSubject,
    status: item.status,
    campaignId: options?.campaignId ?? item.campaignId,
    campaignName: options?.campaignName ?? item.campaignName,
  }));
};
